<template>
  <div class="left-panel" :class="{ hidden: !isOpen }">
    <div
      class="left-panel__toggler"
      :class="{ hidden: !isOpen }"
      @click="isOpen = !isOpen"
    >
      <component :is="icon" size="18" />
    </div>
    <panel class="left-panel__panel" :class="{ hidden: !isOpen }"
      ><slot>left-panel-content</slot></panel
    >
  </div>
</template>

<script>
import { ArrowLeftIcon, ArrowRightIcon } from 'vue-feather-icons'
import Panel from '@anagraph/panel'
export default {
  components: {
    ArrowLeftIcon,
    ArrowRightIcon,
    Panel
  },
  props: {
    initIsOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpen: this.initIsOpen
    }
  },
  computed: {
    icon() {
      return `arrow-${this.isOpen ? 'left' : 'right'}-icon`
    }
  }
}
</script>

<style lang="scss" scoped>
.left-panel {
  position: absolute;
  z-index: 100;
  top: 50px;
  left: 50px;
  transition: width ease-in 0.2s;
  &__panel {
    transition: all ease-in 0.5s;
    opacity: 1;
    width: 300px;
    &.hidden {
      width: 0px;
      opacity: 0;
      transition: all ease-out 0.2s;
    }
  }
  &__toggler {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    height: 30px;
    width: 30px;
    box-shadow: -4px 4px 7px -3px rgba(0, 0, 0, 0.18);
    background-color: white;
    z-index: 200;
    top: -16px;
    right: -16px;
    &.hidden {
      left: 0px;
    }
  }
}
</style>
